import { Button } from "@/components";
import type { Group } from "../../_types/groups.types";
import { GroupListItem } from "../group-list-item";
import styles from "./GroupsList.module.scss";

type GroupsListProps = {
  groups: Group[];
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
  onSelect: (group: Group) => void;
};

export const GroupsList = ({
  groups,
  isLoading,
  isFetching,
  isError,
  onRetry,
  onSelect,
}: GroupsListProps) => {
  if (isLoading) {
    return (
      <div className={styles["comp__state"]}>
        <div className={styles["comp__spinner"]} />
        <div>Loading groups...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles["comp__state"]}>
        <div>Failed to load groups.</div>
        <Button size="small" variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }

  if (groups.length === 0) {
    return <div className={styles["comp__state"]}>No groups found.</div>;
  }

  return (
    <div className={styles["comp"]} aria-busy={isFetching}>
      <div className={styles["comp__table-header"]}>
        <div className={styles["comp__column"]}>Group</div>
        <div className={styles["comp__column"]}>Type</div>
        <div className={styles["comp__column"]}>Members</div>
        <div className={styles["comp__column"]}>Created</div>
        <div className={styles["comp__column"]}>Updated</div>
      </div>

      <div className={styles["comp__list"]}>
        {groups.map((group) => (
          <GroupListItem
            key={group.id}
            group={group}
            onClick={() => onSelect(group)}
          />
        ))}

      </div>
    </div>
  );
};
